// src/web/client/src/components/ShopifyAppBridge.jsx
import React, { useEffect } from 'react';
import { saveSessionToken } from '../utils/shopifyAuth';

export const AppBridgeContext = React.createContext(null);

export default function ShopifyAppBridge({ children }) {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    
    // Save host
    const host = params.get('host');
    if (host) {
      localStorage.setItem('shopify_host', host);
    }
    
    // Save shop
    const shop = params.get('shop');
    if (shop) {
      localStorage.setItem('shop_domain', shop);
      localStorage.setItem('shopDomain', shop);
    }
    
    // Save session token
    saveSessionToken();
    
    console.log('[AppBridge] Params saved to localStorage');
  }, []);

  return (
    <AppBridgeContext.Provider value={null}>
      {children}
    </AppBridgeContext.Provider>
  );
}